import React from "react";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";
import { DefaultButtonGroupVertSplitCode } from "./DefaultButtonGroupVertSplitCode";

const DefaultButtonGroupVertSplit = () => {
  return (
    <>
      <PreviewAndEditor
        language="js"
        title={"Contained vertically split button group"}
        value={
          'import React from "react";\n' +
          "import {\n" +
          "  Button,\n" +
          "  ButtonGroup,\n" +
          "  ClickAwayListener,\n" +
          "  Grow,\n" +
          "  MenuItem,\n" +
          "  MenuList,\n" +
          "  Paper,\n" +
          "  Popper,\n" +
          '} from "@mui/material";\n' +
          'import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";\n' +
          "\n" +
          'const options = ["One", "Two", "Three"];\n' +
          "\n" +
          "export const DefaultButtonGroupVertSplitCode = () => {\n" +
          "  const [open, setOpen] = React.useState(false);\n" +
          "  const anchorRef = React.useRef(null);\n" +
          "  const [selectedIndex, setSelectedIndex] = React.useState(1);\n" +
          "\n" +
          "  const handleMenuItemClick = (event, index) => {\n" +
          "    setSelectedIndex(index);\n" +
          "    setOpen(false);\n" +
          "  };\n" +
          "\n" +
          "  const handleToggle = () => {\n" +
          "    setOpen((prevOpen) => !prevOpen);\n" +
          "  };\n" +
          "\n" +
          "  const handleClose = (event) => {\n" +
          "    if (anchorRef.current && anchorRef.current.contains(event.target)) {\n" +
          "      return;\n" +
          "    }\n" +
          "    setOpen(false);\n" +
          "  };\n" +
          "\n" +
          "  return (\n" +
          "    <>\n" +
          "      <ButtonGroup\n" +
          '        orientation="vertical"\n' +
          "        ref={anchorRef}\n" +
          '        aria-label="vertical split button"\n' +
          "      >\n" +
          "        <Button>{options[selectedIndex]}</Button>\n" +
          "        <Button\n" +
          '          size="small"\n' +
          '          aria-controls={open ? "split-button-menu" : undefined}\n' +
          '          aria-expanded={open ? "true" : undefined}\n' +
          '          aria-label="select merge strategy"\n' +
          '          aria-haspopup="menu"\n' +
          "          onClick={handleToggle}\n" +
          "        >\n" +
          "          <ArrowDropDownIcon />\n" +
          "        </Button>\n" +
          "      </ButtonGroup>\n" +
          "      <Popper\n" +
          "        sx={{\n" +
          "          zIndex: 1,\n" +
          "        }}\n" +
          "        open={open}\n" +
          "        anchorEl={anchorRef.current}\n" +
          "        role={undefined}\n" +
          "        transition\n" +
          "        disablePortal\n" +
          '        placement={"bottom-end"}\n' +
          "      >\n" +
          "        {({ TransitionProps, placement }) => (\n" +
          "          <Grow\n" +
          "            {...TransitionProps}\n" +
          "            style={{\n" +
          "              transformOrigin:\n" +
          '                placement === "bottom-end" ? "right top" : "right bottom",\n' +
          "            }}\n" +
          "          >\n" +
          "            <Paper>\n" +
          "              <ClickAwayListener onClickAway={handleClose}>\n" +
          '                <MenuList id="split-button-menu" autoFocusItem>\n' +
          "                  {options.map((option, index) => (\n" +
          "                    <MenuItem\n" +
          "                      key={option}\n" +
          "                      disabled={index === 2}\n" +
          "                      selected={index === selectedIndex}\n" +
          "                      onClick={(event) => handleMenuItemClick(event, index)}\n" +
          "                    >\n" +
          "                      {option}\n" +
          "                    </MenuItem>\n" +
          "                  ))}\n" +
          "                </MenuList>\n" +
          "              </ClickAwayListener>\n" +
          "            </Paper>\n" +
          "          </Grow>\n" +
          "        )}\n" +
          "      </Popper>\n" +
          "    </>\n" +
          "  );\n" +
          "};\n" +
          "\n"
        }
      >
        <DefaultButtonGroupVertSplitCode />
      </PreviewAndEditor>
    </>
  );
};

export default DefaultButtonGroupVertSplit;
